import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    ml: 2,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
